// extracted by mini-css-extract-plugin
export default {"baseStyles":"_8lcmd"};